import { observer } from 'mobx-react-lite';
import { debounce, TranslationKeys, useTranslation } from '@pascal/pascal-core';
import { resultStore } from '../../module/store/resultStore';
import { gameStore } from '../../module/store/gameStore';
import { userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { TKeys } from '../../core/constants/TKeys';
import { gameService } from '../../module/gameLiveConnection/gameService';
import { useCallback } from 'react';

export const Popups = observer((props) => {
  const t = useTranslation()
  const { cashOutResult } = resultStore
  const { resultReportState } = gameStore

  const handlePopupClick = debounce(useCallback(() => {
    gameService.resetResults()
  },[]), 150, { isImmediate: false })

  return(
    <div className='popup-wrapper' style = {{display: cashOutResult && resultReportState ? '' : 'none'}} onClick={handlePopupClick}>
      <div className={`win-block`} style = {{display: cashOutResult ? '' : 'none'}}>
        <div className='win-text-bl'>
          <div className='win-content'>
            <p className='win-content-text'>{t(TKeys.YouWin)}</p>
            <p className='win-content-money'>{cashOutResult?.winAmount} {userInfoStore.currencySymbolOrCode}</p>
          </div>
        </div>
      </div>
      {/*<div className='lost-block' style = {{display: betResult?.status === betStatus.lose ? '' : 'none'}}>*/}
      {/*  <div className='lost-text-bl'>*/}
      {/*    <div className='lost-content'>*/}
      {/*      <p className='lost-content-text'>No win</p>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}
    </div>
  )
});

